import React from 'react';
import { useNavigation } from 'shared-utils';
import { Button } from 'shared-ui';
import { PlusIcon } from '../../../components/Icons';
import CreateBioTypeModal from './CreateBioTypeModal';

const HeaderAction: React.FC = () => {
    const { push: navigate } = useNavigation();
    const [showCreateBioType, setShowCreateBioType] = React.useState(false);

    const handleObservationTypeCreateCompletion = (observationTypeId: number) => {
        // navigate(ObservationTypeDetailsNavigation(customerId));
    };

    return (
        <>
            <Button
                color="primary"
                startIcon={(<PlusIcon />)}
                onClick={() => setShowCreateBioType(true)}
            >
                Ajouter un type de protection
            </Button>
            {showCreateBioType && (
                <CreateBioTypeModal
                    onClose={() => setShowCreateBioType(false)}
                    onCompletion={handleObservationTypeCreateCompletion}
                />
            )}
        </>
    );
};

export default HeaderAction;
